import { useTranslation } from 'react-i18next'
import { Checkbox, Input } from '@structural-climbing/ui'
import { discountedPrice } from './usePlanDiscount'
import type { PlanDiscount } from './usePlanDiscount'
import type { GymPlan } from './types'

interface PlanPriceFieldsProps {
  plan: GymPlan
  pricePaid: string
  onPricePaidChange: (value: string) => void
  discount: PlanDiscount
  /** Show the plan's list price under Price Paid. */
  showListPriceHint?: boolean
}

export function PlanPriceFields({
  plan,
  pricePaid,
  onPricePaidChange,
  discount,
  showListPriceHint = true,
}: PlanPriceFieldsProps) {
  const { t } = useTranslation()

  return (
    <>
      <Checkbox isSelected={discount.hasDiscount} onValueChange={discount.toggle}>
        {t('assignPlan.discountToggle')}
      </Checkbox>
      <div className={discount.hasDiscount ? 'grid gap-3 sm:grid-cols-2' : undefined}>
        {discount.hasDiscount && (
          <Input
            label={t('assignPlan.discountLabel')}
            type="number"
            min="1"
            max="100"
            step="1"
            value={discount.discountPercent}
            onValueChange={discount.changePercent}
            endContent={<span className="text-sm text-foreground/50">%</span>}
            description={t('assignPlan.discountDescription', {
              amount: (plan.price - discountedPrice(plan.price, discount.discountPercent)).toFixed(
                2,
              ),
              price: plan.price.toFixed(2),
              currency: plan.currency,
            })}
          />
        )}
        <Input
          label={t('assignPlan.pricePaidLabel')}
          type="number"
          min="0"
          step="0.01"
          value={pricePaid}
          onValueChange={onPricePaidChange}
          description={
            showListPriceHint
              ? t('assignPlan.pricePaidDescription', {
                  price: plan.price.toFixed(2),
                  currency: plan.currency,
                })
              : undefined
          }
        />
      </div>
    </>
  )
}
